export const PITCH_WIDTH = 120;
export const PITCH_HEIGHT = 80;
export const SCALE_FACTOR = 10;
